import { render, staticRenderFns } from "./BaseAdminTag.vue?vue&type=template&id=5560ef10&scoped=true&"
import script from "./BaseAdminTag.vue?vue&type=script&lang=js&"
export * from "./BaseAdminTag.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/base.css?vue&type=style&index=0&id=5560ef10&scoped=true&lang=css&"
import style1 from "./BaseAdminTag.vue?vue&type=style&index=1&id=5560ef10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5560ef10",
  null
  
)

export default component.exports